import { ref, toRef } from 'vue'

export function useFocusElement(component, callback, excludeComponent) {
  const root = toRef(component);

  const focusableElements = [
    'a[href]:not([tabindex^="-"])',
    'area[href]:not([tabindex^="-"])',
    'input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"])',
    'input[type="radio"]:not([disabled]):not([tabindex^="-"]):checked',
    'select:not([disabled]):not([tabindex^="-"])',
    'textarea:not([disabled]):not([tabindex^="-"])',
    'button:not([disabled]):not([tabindex^="-"])',
    'iframe:not([tabindex^="-"])',
    'audio[controls]:not([tabindex^="-"])',
    'video[controls]:not([tabindex^="-"])',
    '[contenteditable]:not([tabindex^="-"])',
    '[tabindex]:not([tabindex^="-"])',
  ];

  function getFocusableChildren() {
    if (!root.value) return false;

    return [...root.value.querySelectorAll(focusableElements.join(','))]
  }

  async function focusFirstElement() {
    // The element can be unmounted before a deferred focus call runs (e.g. the
    // sheet closes during its enter transition).
    if (!root.value) return;

    const firstElement = root.value.tabIndex === -1 ? root.value : getFocusableChildren()[0];

    if (!firstElement) return;

    firstElement.focus({ focusVisible: true });
  }

  return { focusableElements, focusFirstElement, getFocusableChildren }
}
